import React from 'react'

const Input = ({ filter, setFilter }) => (
  <input
    className="form-control pl-4 py-3"
    placeholder="Filter by name..."
    key="input"
    onChange={(e)=>setFilter(e.target.value)}
    value={filter} />
)

export const useFilter = () => {
  const [ filter, setFilter ] = React.useState('')
  return [ filter, setFilter, Input ]
}